import { createStore } from 'vuex'

export default createStore({
  state: {
     userToken: sessionStorage.getItem("prayer_usertoken") ? sessionStorage.getItem("prayer_usertoken") : null,
     userName: sessionStorage.getItem("prayer_userName") ? sessionStorage.getItem("prayer_userName") : null,
     captchaDependenciesLoaded: false
  },
  mutations: {
  	userToken(state, token){
      sessionStorage.setItem("prayer_usertoken", token);
      state.userToken = token;
    },
    userName(state, name){
      sessionStorage.setItem("prayer_userName", name);
      state.userName = name;
    },

    captchaDependenciesLoaded(state){
      state.captchaDependenciesLoaded = true;
    }
  },
  actions: {
  },
  modules: {
  }
})
